import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

const fmtD = (iso) => (iso ? iso.split("-").reverse().join(".") : "");

export default function DeclaredAbuseBanner() {
  const [rows, setRows] = useState([]);
  const [approvals, setApprovals] = useState([]);
  const [open, setOpen] = useState(true);

  const load = () => {
    api.get("/admin/declared-abuse?days=7&min_sites=4").then((r) => setRows(r.data || [])).catch(() => setRows([]));
    api.get("/admin/declared-approvals?status=pending").then((r) => setApprovals(r.data || [])).catch(() => setApprovals([]));
  };
  useEffect(load, []);

  const resolve = async (a, approve) => {
    try {
      await api.post(`/admin/declared-approvals/${a.id}/resolve`, { approve });
      toast.success(approve ? `Aprobat: ${a.user_name} → ${a.site_label}` : `Respins: ${a.user_name} → ${a.site_label}`);
      setApprovals((list) => list.filter((x) => x.id !== a.id));
    } catch (e) { toast.error(e?.response?.data?.detail || "Eroare"); }
  };

  if (!rows.length && !approvals.length) return null;
  return (
    <div className="rounded-lg border-2 border-purple-400 bg-purple-50 overflow-hidden" data-testid="declared-abuse-banner">
      <button onClick={() => setOpen((v) => !v)} className="w-full px-4 py-2.5 flex items-center gap-2 text-left">
        <span className="font-bold text-sm text-purple-900">
          🕵️ Șantiere „declarate": {approvals.length > 0 && <span className="text-red-700">{approvals.length} cereri de aprobat</span>}
          {approvals.length > 0 && rows.length > 0 && " · "}
          {rows.length > 0 && `${rows.length} posibile abuzuri (7 zile)`}
        </span>
        <span className="ml-auto text-purple-700 text-xs font-bold">{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div className="px-4 pb-3 space-y-1.5">
          {approvals.length > 0 && (
            <>
              <div className="text-[11px] font-bold text-red-700 uppercase">Cereri pentru al 4-lea+ șantier declarat în aceeași zi:</div>
              {approvals.map((a) => (
                <div key={a.id} className="bg-white border border-red-200 rounded px-3 py-1.5 text-sm flex flex-wrap items-center gap-x-3 gap-y-1" data-testid={`approval-row-${a.id}`}>
                  <b>{a.user_name || "—"}</b>
                  <span className="text-xs text-zinc-500 tabular-nums">{fmtD(a.day)}</span>
                  <span className="text-xs font-semibold">🏗 {a.site_label}</span>
                  <span className="ml-auto inline-flex gap-1.5">
                    <button onClick={() => resolve(a, true)} className="text-xs font-bold px-2 py-1 rounded bg-emerald-600 text-white hover:bg-emerald-700" data-testid={`approve-${a.id}`}>✔ Aprobă</button>
                    <button onClick={() => resolve(a, false)} className="text-xs font-bold px-2 py-1 rounded bg-red-600 text-white hover:bg-red-700" data-testid={`reject-${a.id}`}>✖ Respinge</button>
                  </span>
                </div>
              ))}
            </>
          )}
          {rows.length > 0 && (
            <>
              <div className="text-[11px] text-purple-700">Utilizatori care au declarat ≥4 șantiere diferite în aceeași zi — probabil doar ca să vadă orele.</div>
              {rows.map((r) => (
                <div key={`${r.user_id}-${r.day}`} className="bg-white border border-purple-200 rounded px-3 py-1.5 text-sm flex flex-wrap items-center gap-x-3 gap-y-0.5" data-testid={`abuse-row-${r.user_id}-${r.day}`}>
                  <b>{r.user_name || "—"}</b>
                  <span className="text-xs text-zinc-500 tabular-nums">{fmtD(r.day)}</span>
                  <span className="text-xs font-bold text-purple-800">{r.sites_count} șantiere · {r.views} vizualizări</span>
                  <span className="text-[11px] text-zinc-500 truncate">{(r.sites || []).join(", ")}</span>
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
}
